<h2 mat-dialog-title>{{ 'GLOBAL.DOCUMENTS' | translate }}</h2>

<mat-dialog-content>
    <field-holder>
        <mat-form-field appearance="outline" class="search centar-search">
            <mat-label>
                {{ 'GLOBAL.CENTER' | translate }}
            </mat-label>
            <input type="text" matInput [formControl]="centerControl" [matAutocomplete]="autoCenter" required />
            <mat-autocomplete panelWidth="auto" #autoCenter="matAutocomplete" [displayWith]="displayCustomFormat">
                <mat-option *ngFor="let center of filteredCenters | async" [value]="center">
                    {{ center.name }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </field-holder>
    <field-holder>
        <mat-form-field appearance="outline">
            <mat-label>{{ 'GLOBAL.COMMENT' | translate }}</mat-label>
            <textarea matInput type="text" [formControl]="commentControl" autocomplete="off"></textarea>
        </mat-form-field>
    </field-holder>
    <div class="select-all-row">
        <mat-checkbox [checked]="allSelected" [indeterminate]="someSelected" (change)="toggleAll($event.checked)"
            color="primary">
            {{ 'SENDING-DOCUMENTS.TO_ANOTHER_CSR.SELECT_ALL_DOCUMENTS' | translate }}
        </mat-checkbox>
    </div>
    <div class="documents-list">
        <div class="document-row" *ngFor="let document of documents; trackBy: trackByDocumentId">
            <mat-checkbox [checked]="isSelected(document)" (change)="toggleDocument(document, $event.checked)"
                color="primary">
            </mat-checkbox>
            <span class="document-name" [matTooltip]="document.name">
                {{ document.name }}
            </span>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">
        {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button mat-raised-button color="primary" type="button" [disabled]="selectedDocuments.size === 0"
        (click)="confirm()">
        {{ 'SENDING-DOCUMENTS.TO_ANOTHER_CSR.ADD_CENTER' | translate }}
    </button>

</mat-dialog-actions>